import LoadingTermImage from "./loading_term_image"
import ImageGalleryCaption from "./image_gallery_caption"
import ZoomIcon from "components/zoom_icon"
import class_names from "classnames"
import React, {useState} from "react"
import viewport_helper from "viewport_helper"
import {Virtual} from "swiper/modules"
import {Swiper, SwiperSlide} from "swiper/react"
import FaIcon from "components/fa_icon"
import {use_image_gallery} from "./image_gallery_provider"

// any css file here should be also added to
// app/javascript/packs/article_editor.js
import "swiper/css"
import "swiper/css/virtual"

function ImageGallery({images}) {
  images = images || use_image_gallery()
  const [swiper, set_swiper] = useState(null)
  const [is_extended, set_is_extended] = useState(false)
  const [gallery_element, set_gallery_element] = useState(null)
  const [current_image_index, set_current_image_index] = useState(0)

  if (!images.length) return null

  const show_image = (image) => {
    if (!gallery_element) return
    const vertical_percentage_in_viewport =
      viewport_helper.vertical_percentage_in_viewport(gallery_element)
    if (vertical_percentage_in_viewport < 50) {
      viewport_helper.go_to(gallery_element)
    }
    swiper.slideTo(images.indexOf(image))
  }

  const toggle_size = () => {
    gallery_element.parentElement.classList.toggle("extended")
    set_is_extended(!is_extended)
  }

  const get_image_url = (image) => (
    is_inlined() && !is_extended && image.small_image_url
      ? image.small_image_url
      : image.image_url
  )

  const is_inlined = () => {
    if (!gallery_element) return false

    const class_list = gallery_element.parentElement.classList
    return [
      "outset-left",
      "outset-right"
    ].some(name => class_list.contains(name))
  }

  const class_name = class_names("image-gallery", {
    "single-image": images.length === 1
  })
  return (
    <div className={class_name} ref={set_gallery_element}>
      <div className="image-gallery__container">
        <ExtendableIcon is_extended={is_extended} toggle_size={toggle_size}/>
        <ZoomIcon
          allow_fullscreen={!!images[0].fullscreen_url}
          source={"image gallery"}
          images={images}
          current_image={images[current_image_index]}
        />
        {images.length > 1 && (
          <>
            <div
              className="image-gallery__prev"
              onClick={() => swiper.slidePrev()}
            >
              <div><FaIcon name={"fa-angle-left"}/></div>
            </div>
            <div
              className="image-gallery__next"
              onClick={() => swiper.slideNext()}
            >
              <div><FaIcon name={"fa-angle-right"}/></div>
            </div>
          </>
        )}
        <Swiper
          modules={[Virtual]}
          onSwiper={set_swiper}
          onSlideChange={(swiper) =>
            set_current_image_index(swiper.activeIndex)}
          slidesPerView={1}
          virtual={true}
          rewind={true}
        >
          {images.map((image, index) => (
            <SwiperSlide key={image.image_url} virtualIndex={index}>
              <LoadingTermImage
                image={{...image, image_url: get_image_url(image)}}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <ImageGalleryCaption
        images={images}
        show_image={show_image}
        current_image_index={current_image_index}
        next_item={() => swiper.slideNext()}
        previous_item={() => swiper.slidePrev()}
      />
    </div>
  )
}

const ExtendableIcon = ({is_extended, toggle_size}) => (
  <div
    className={class_names(
      "image-extendable",
      {"image-extendable--active": is_extended}
    )}
    onClick={toggle_size}
  >
    <FaIcon name={is_extended ? "fa-compress" : "fa-expand"} />
  </div>
)

export default ImageGallery
